// extracted by mini-css-extract-plugin
module.exports = {"Menu":"bgs_a bhh_h","Menu__offsetParent":"bgs_b bhh_bj","Menu__trigger--shadowed":"bgs_c"};